<template>
	<div class="pagination-bar-view">
		<alphabet-view :index="pagination.index" @update:index="updateIndex" />
		<pagination-view :count="pagination.count" :page="pagination.page" @update:page="updatePage" />
	</div>
</template>

<script>
	export default {
		props: {
			pagination: {
				type: Object,
				required: true,
				validator(value) {
					return value.hasOwnProperty('count') && value.hasOwnProperty('page');
				}
			}
		},
		methods: {
			updatePage(page) {
				this.$emit('update:pagination', { ...this.pagination, page });
			},
			updateIndex(index) {
				this.$emit('update:pagination', { ...this.pagination, index, page: 1 });
			}
		}
	}
</script>

<style lang="scss" scoped>
	.pagination-bar-view {
		display: grid;
		grid-template-columns: 1fr auto;
	}
</style>